import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import ContentUnitIcon from "./content-unit-icon";
import InnogyStyleIcon from "../innogy-style-icon";
import BaseComponent from "../base-component";

class ContentUnitHeader extends BaseComponent {

    render() {
        const { contentUnit, intl, hideEstimatedTime, hideDescription, hideInnogyStyle } = this.props;
        const { title, innogy_style, estimated_time, description } = contentUnit;

        return (
            <div className='content-unit-header'>
                <div className='bg-gray'>
                    <div className='container pt-4 pb-4 mb-4'>
                        <ContentUnitIcon contentUnit={contentUnit} fill={'#ffffff'} className='content-icon'/>
                        <h1>{ title }</h1>
                    </div>
                </div>
                {
                    innogy_style && !hideInnogyStyle &&
                    <div className='container mt-4 mb-4 innogy-style'>
                        <InnogyStyleIcon style={innogy_style} className={'mr-2'}/>
                        { intl.formatMessage({ id: `app.content_units.innogy_styles.${innogy_style}` }) }
                    </div>
                }
                {
                    estimated_time && estimated_time > 0 && !hideEstimatedTime &&
                    <div className='container mt-4 mb-4'>
                        <p><FormattedMessage id='app.content_units.attribute.estimated_time'/>: { estimated_time } min</p>
                    </div>
                }
                {
                    description && description.length > 0 && !description &&
                    <div className='container mt-4 mb-4'>
                        {description}
                    </div>
                }
            </div>
        )
    };
}

export default injectIntl(ContentUnitHeader);
